import { render, staticRenderFns } from "./ShoppingCartItemDelete.vue?vue&type=template&id=05f37e0c"
import script from "./ShoppingCartItemDelete.vue?vue&type=script&lang=js"
export * from "./ShoppingCartItemDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports